import { HttpClient } from '@wix/http-client';

export const createMetaSiteByTemplate = async (
  baseUrl: string,
  originTemplateId: string,
): Promise<string> => {
  const httpClient = new HttpClient({ baseURL: baseUrl });
  const { data } = await httpClient.post<{ metaSiteId: string }>(
    '/api/create-metasite',
    { originTemplateId },
  );

  return data.metaSiteId;
};
